import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { accessibilityParamsStore } from 'stores/root';
import { IconComponent } from 'types/IconComponent';
import { Color } from 'types/colors';
import { getColor } from 'utils/getColor';

import s from './IconWrapper.module.scss';

export type IconSizeProps =
  | {
      size?: string | number;
      width?: never;
      height?: never;
    }
  | {
      size?: never;
      width?: string | number;
      height?: string | number;
    };

export type IconBaseProps = Omit<React.ComponentProps<'svg'>, 'width' | 'height' | 'color'> & {
  className?: string;
  title?: string;
  color?: Color;
};

export type IconProps = IconBaseProps & IconSizeProps & React.AriaAttributes;

export const withIconWrapper = (Component: IconComponent) =>
  observer(({ className, size, width, height, color, ...props }: IconProps) => {
    const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

    const iconWidth = width || size;
    const iconHeight = height || size;
    const computedColor = isAccessibilityMode ? 'var(--color-text)' : color ? getColor(color) : undefined;

    return (
      <Component
        className={cn(className, s.icon)}
        style={{ width: iconWidth, height: iconHeight }}
        role="img"
        color={computedColor}
        {...props}
      />
    );
  }) as React.FC<IconProps>;
